// api/authAPI.ts
//import api from './index'
import axios from 'axios';
import type { LoginCredentials, TokenResponse } from '@/types/auth'

const api = axios.create({
  //baseURL: 'http://192.168.1.170:8000/api', // URL en Cloud Vending
  baseURL: process.env.VUE_APP_API_BASE_URL, // URL en casa
  timeout: 5000, // Tiempo máximo de espera
  headers: {
    'Content-Type': 'application/json',
    //'Authorization': `Token a863664b2638bcf6b7e61cfad401d1c6ad221faa`,
    Authorization: `Bearer ${localStorage.getItem('access_token')}` // Asumiendo autenticación
  }
});

export default {
  async login(credentials: LoginCredentials): Promise<TokenResponse> {
    const response = await api.post<TokenResponse>('/token/', credentials)
    return response.data
  },

  async refreshToken(refreshToken: string): Promise<TokenResponse> {
    const response = await api.post<TokenResponse>('/token/refresh/', {
      refresh: refreshToken
    })
    return response.data
  },

  async verifyToken(token: string): Promise<any> {
    const response = await api.post('/token/verify/', {
      token: token
    })
    return response.data
  }
}